import FiniteStateMachine, { ANIMATION_STATE, IdleState, RunningState, WalkingState, } from "@controllers/fsm";
class EnemyFiniteStateMachine extends FiniteStateMachine {
    /**
     * A finite-state machine that controls an enemy's animations.
     * @param animationController The enemy's animation controller.
     */
    constructor(animationController) {
        const states = {
            [ANIMATION_STATE.IDLE]: new IdleState(animationController),
            [ANIMATION_STATE.RUN]: new RunningState(animationController),
            [ANIMATION_STATE.WALK]: new WalkingState(animationController),
        };
        super(states, animationController);
        this.setState(ANIMATION_STATE.IDLE);
    }
}
export default EnemyFiniteStateMachine;
